import { render, staticRenderFns } from "./BatchModifyShortTitle.vue?vue&type=template&id=3128e91f&scoped=true"
import script from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
export * from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyShortTitle.vue?vue&type=style&index=0&id=3128e91f&prod&scoped=true&lang=css"
import style1 from "./batch-modify.css?vue&type=style&index=1&id=3128e91f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128e91f",
  null
  
)

export default component.exports